import { colors } from "Infrastructure/Themes/Colors";

export const EnterIcon = (props: React.SVGProps<SVGSVGElement>) => {
  props = {
    ...props,
    color: props.color,
  };
  return (
    <svg
      width="11"
      height="12"
      viewBox="0 0 11 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11 7.76471L6.6 12L5.55867 10.9976L8.19133 8.47059H0V0H1.46667V7.05882H8.19133L5.55867 4.53176L6.6 3.52941L11 7.76471Z"
        fill={colors().TextLight}
      />
    </svg>
  );
};
